import ChartGrowthColor from './ChartGrowthColour.svg';
import ChartGrowthDark from './ChartGrowthDark.svg';
import ChartGrowthLight from './ChartGrowthLight.svg';
export const chartGrowth = { color: ChartGrowthColor, dark: ChartGrowthDark, light: ChartGrowthLight };
//# sourceMappingURL=index.js.map